import React, { useEffect } from "react";
import { SelectDevices } from "./SelectDevices";

const TITLE = "Navigator Properties";

const navigatorData = [
  {
    id: "navigator",
    label: "Navigator",
  },
];

const SelectNavigatorProperties = ({ selectedDevices, onChange, loadingDevices, disabled }) => {
  useEffect(() => {
    loadingDevices.add(1);
    onChange(navigatorData);
    loadingDevices.done();
  }, []);

  return (
    <SelectDevices
      title={TITLE}
      subtitle={
        <p>
          We are going to collect <br />
          <small>
            platform, vendor, language, languages, hardwareConcurrency, deviceMemory,
            <br />
            connection, plugins, mimeTypes, doNotTrack, bluetooth, vibrate,
            <br />
            virtual keyboard, hovering, automation and usb
          </small>
          <br />
        </p>
      }
      data={navigatorData}
      onChange={onChange}
      selectedDevices={selectedDevices}
      disabled={disabled}
    />
  );
};

export default SelectNavigatorProperties;
